module.exports = __webpack_public_path__ + "img/marble_paint.e43a78d6.jpg";